const INVENTORY_ORDER_QUERY = {
    order_status: {
        _in: ['pending', 'active', 'routed', 'claimed', 'inProgress', 'routedInProgress', 'complete', 'routedComplete'],
    },
};

export const INVENTORY_PAGE_SIZE = 30;
export const INVENTORY_EXPORT_LIMIT = 500;

// The page's two top-level views. Forward stocked inventory used to be the fifth
// status tab, which put it on a level with All and Complete despite being a
// different kind of inventory entirely.
export const PRIMARY_TABS = {
    FORWARD_STOCKING: 'forward_stocking',
    DELIVERY: 'delivery',
};

// Status tabs nested under Delivery. Indices are load-bearing: processOrders and
// processPallets take a tab index and read statusFilter back out of this array.
export const DELIVERY_TABS = [
    {
        label: 'All',
        value: 0,
        orderQuery: INVENTORY_ORDER_QUERY,
    },
    {
        label: 'Not Received',
        value: 1,
        statusFilter: 'NOT_RECEIVED',
        orderQuery: INVENTORY_ORDER_QUERY,
    },
    {
        label: 'In Stock',
        value: 2,
        statusFilter: 'IN_STOCK',
        orderQuery: INVENTORY_ORDER_QUERY,
    },
    {
        label: 'Complete',
        value: 3,
        statusFilter: 'COMPLETE',
        orderQuery: INVENTORY_ORDER_QUERY,
    },
];

export const INVENTORY_CSV_COLUMNS = [
    { header: 'SKU', value: (palletItem) => palletItem.sku || '' },
    { header: 'Pallet Id', value: (palletItem) => palletItem.palletId || '' },
    { header: 'Order Number', value: (palletItem) => palletItem.order_number || '' },
    { header: 'PO Number', value: (palletItem) => palletItem.po_number || '' },
    { header: 'Shipper', value: (palletItem) => palletItem.shipper || '' },
    { header: 'Qty In', value: (palletItem) => `${Math.round(Number(palletItem.qtyIn) || 0)}` },
    { header: 'Qty Out', value: (palletItem) => `${Math.round(Number(palletItem.qtyOut) || 0)}` },
    { header: 'Qty On Hand', value: (palletItem) => `${Math.round(Number(palletItem.qtyOnHand) || 0)}` },
    { header: 'Qty Total', value: (palletItem) => `${Math.round(Number(palletItem.qtyTotal) || 0)}` },
    { header: 'Bins/Locations', value: (palletItem) => palletItem.locations || '-' },
    { header: 'Date In', value: (palletItem) => palletItem.dateIn || '' },
    { header: 'Date Out', value: (palletItem) => palletItem.dateOut || '' },
    { header: 'Inbound Manifests', value: (palletItem) => palletItem.inboundManifests || '-' },
    { header: 'Outbound Manifests', value: (palletItem) => palletItem.outboundManifests || '-' },
    { header: 'Status', value: (palletItem) => palletItem.status || 'Not Received' },
    { header: 'Exceptions', value: (palletItem) => palletItem?.exceptions?.length || 0 },
];
